import React, { useState, useEffect } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

const filter_data = [
  {
    name: "Orders",
    value: "1",
  },
  {
    name: "Orders History",
    value: "2",
  },
  {
    name: "Completed Orders",
    value: "3",
  },
];

const table_header = [
  {
    name: "Customer Name",
    width: "30",
  },
  {
    name: "Event Name",
    width: "20",
  },
  {
    name: "Amount",
    width: "10",
  },
  {
    name: "Pending",
    width: "10",
  },
  {
    name: "Status",
    width: "20",
  },
  {
    name: "",
    width: "10",
  },
];

export default function OutletOrder(props: any) {
  const [order_data, SetOrderData] = useState([]);
  const [pageTitle, SetPageTitle] = useState("Order Details");
  let { orderStatus } = useParams<"orderStatus">();
  const [id_value, SerIdValue] = useState(useParams());

  const [timer, SetTimer] = useState(null);
  const [selected_filter, setSelectedFilter] = useState("1");
  const WAIT_INTERVAL = 700;

  const [page_no, SetPageNo] = useState(1);
  const [next_page, SetNextPage] = useState(false);
  const [table_change_value, SetTableChangeValue] = useState({
    filter_value: "",
    page_number: 1,
    page_size: 10,
    sort_order: false,
  });

  useEffect(() => {
    console.log("OutletOrder On mount :", props);
    if (orderStatus == "history") {
      SetPageTitle("Order History");
    } else if (orderStatus == "cancelled") {
      SetPageTitle("Cancelled Order");
    }
    get_orders(table_change_value, page_no, selected_filter);
  }, []);

  async function get_orders(data: any, page_no_value: any, filter_value: any) {
    let count_value, sort_order_value;
    if (data.page_size == "0") {
      count_value = "all";
    } else {
      count_value = data.page_size;
    }
    if (data.sort_order == false) {
      sort_order_value = { column: "", order: "" };
    } else {
      sort_order_value = data.sort_order;
    }
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        page: page_no_value,
        count: count_value,
        search: data.filter_value,
        sort: sort_order_value.order,
        sort_by: sort_order_value.column,
        filter: filter_value,
      },
    };
    let data_res = await api("/outlet/orders", pass_data);
    console.log("response :", data_res.response);
    SetNextPage(data_res.response.next_page);
    if (data_res.response.hasOwnProperty("orders")) {
      SetOrderData(data_res.response.orders);
    }
  }

  function tableChangeHandler(data) {
    console.log("tableChangeHandler :", data);

    SetTableChangeValue((prevValue) => {
      if (data.filter_value == prevValue.filter_value) {
        console.log("Filter Value not Changed");
        get_orders(data, page_no, selected_filter);
      } else {
        clearTimeout(timer);
        console.log("Filter Value Changed");
        SetTimer(
          setTimeout(() => {
            get_orders(data, page_no, selected_filter);
          }, WAIT_INTERVAL)
        );
      }
      return data;
    });
  }

  return (
    <div>
      <div className="bg-fff pt-3 px-4 row align-items-center">
        <div className="col-6 col-md-5">
          <h5 className="  mb-0 text-dark fw-bolder">{pageTitle}</h5>
          {/* <p className="v-small mb-0">500+ orders</p> */}
        </div>
        <div className="col-6 col-md-7 justify-content-end d-flex align-items-center">
          <Link
            to={
              "/outlet/" +
              id_value.brand_id +
              "/" +
              id_value.outlet_id +
              "/order/addorder/"
            }
          >
            <div className="d-flex align-items-center text-dark cursor pe-3 ">
              <img
                src={require("../../../assets/icon/svg/plus1.svg")}
                className=" pe-2"
              />{" "}
              Add
            </div>
          </Link>
          <div>
            <div className="ms-2 ps-2 cursor dropdown">
              <div
                className=" d-flex align-items-center"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={require("../../../assets/icon/svg/sliders1.svg")}
                  className="header-icon-img"
                />
                <p className="mb-0 text-dark ps-2">Filter</p>
              </div>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                {filter_data.map((f_ele, f_index) => (
                  <li
                    key={f_index}
                    onClick={() => {
                      setSelectedFilter((prevValue) => {
                        get_orders(table_change_value, page_no, f_ele.value);
                        return f_ele.value;
                      });
                    }}
                    className={
                      selected_filter == f_ele.value
                        ? "active_filter p-1"
                        : "cursor p-1 text-dark"
                    }
                  >
                    <a className="dropdown-item" href="#">
                      {f_ele.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container p-3">
        <div className="card p-3">
          <div className="row pb-3">
            <div className="col-md-8 pb-2">
              <div className="d-flex align-items-center">
                <p className="mb-0 pe-2">Show</p>
                <select
                  className="form-select flex-basis-20"
                  defaultValue={10}
                  aria-label="Default select example"
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                </select>
                <p className="mb-0 ps-2">records per page</p>
              </div>
            </div>
            <div className="col-md-4 pb-2 text-end">
              <input
                type="text"
                className="form-control"
                id="staticEmail"
                placeholder="Search in recors..."
              />
            </div>
          </div>

          <div className="d-lg-block d-md-none">
            <table className="table table-hover ">
              <thead>
                <tr>
                  {table_header.map((head, t_index) => (
                    <th
                      className={"custom-table-header flex-basis-" + head.width}
                      key={t_index}
                    >
                      {head.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {order_data.map((data, o_index) => (
                  <tr className="" key={o_index}>
                    <td className="flex-basis-30">
                      <p className="mb-1">{data.company_name}</p>
                      <p className="v-small">{data.client_name}</p>
                    </td>
                    <td className="flex-basis-20">{data.events_name}</td>
                    <td>{data.total_amount}</td>
                    <td className="flex-basis-10">{data.pending_amount}</td>
                    <td className="flex-basis-20">{data.order_status}</td>
                    <td className="dropdown flex-basis-10 cursor">
                      <div
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={require("../../../assets/icon/svg/more-horizontal.svg")}
                          className="action_img cursor"
                        />
                      </div>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton2"
                      >
                        <li>
                          <Link
                            to={
                              "/outlet/" +
                              id_value.brand_id +
                              "/" +
                              id_value.outlet_id +
                              "/order/vieworder/" +
                              data.id
                            }
                            className="dropdown-item"
                          >
                            <img
                              src={require("../../../assets/icon/svg/eye.svg")}
                              className="action_menu_img cursor"
                            />
                            &nbsp; View
                          </Link>
                        </li>
                      </ul>
                    </td>
                    {/* </div>
                      </div> */}
                    {/* </div> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-lg-none">
            {order_data.map((data, o_index) => (
              <div className="row border-bottom" key={o_index}>
                <div className="col-12 mt-1">
                  <h6 className="mb-1">{data.company_name}</h6>
                  <p className="v-small">{data.client_name}</p>
                </div>
                <div className="col-6 mt-1">
                  <p>{data.events_name}</p>
                </div>
                <div className="col-6 mt-1 text-end">
                  <p>{data.order_status}</p>
                </div>
                <div className="col-6 mt-1">
                  <p className="text-dark">₹&nbsp;{data.pending_amount}</p>
                </div>
                <div className="col-6 text-end mt-1">
                  <p className="text-dark">₹&nbsp;{data.total_amount}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="row align-items-center">
            <div className="col-md-4">
              <p>Showing 1 to 8 of 8 enteries </p>
            </div>
            <div className="col-md-8">
              <nav className="Pager1" aria-label="pagination example">
                <ul className="pagination pagination-circle justify-content-center">
                  <li className="page-item disabled">
                    <a className="page-link">First</a>
                  </li>

                  <li className="page-item disabled">
                    <a className="page-link" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </a>
                  </li>

                  <li className="page-item active">
                    <a className="page-link">1</a>
                  </li>
                  <li className="page-item">
                    <a className="page-link">2</a>
                  </li>
                  <li className="page-item">
                    <a className="page-link">3</a>
                  </li>
                  <li className="page-item">
                    <a className="page-link">4</a>
                  </li>
                  <li className="page-item">
                    <a className="page-link">5</a>
                  </li>

                  <li className="page-item">
                    <a className="page-link" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span className="sr-only">Next</span>
                    </a>
                  </li>

                  <li className="page-item">
                    <a className="page-link">Last</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end pe-3 py-2">
          {page_no != 1 ? (
            <button
              type="button"
              className="page-link br-1"
              onClick={() => {
                SetPageNo((prevValue) => {
                  let page_no_value = prevValue - 1;
                  get_orders(
                    table_change_value,
                    page_no_value,
                    selected_filter
                  );
                  return page_no_value;
                });
              }}
            >
              Previous
            </button>
          ) : null}
          {next_page ? (
            <button
              type="button"
              className="page-link br-1"
              onClick={() => {
                SetPageNo((prevValue) => {
                  let page_no_value = prevValue + 1;
                  get_orders(
                    table_change_value,
                    page_no_value,
                    selected_filter
                  );
                  return page_no_value;
                });
              }}
            >
              Next
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
